import React from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import App from './App';
import PreferenceComponent from './components/PreferenceComponent';
import SuccessComponent from './components/SuccessComponent';
import ErrorComponent from './components/ErrorComponent';

function Router() {
  return (
    <HashRouter>
      <Switch>
        <Route exact path="/" component={App} />
        <Route path="/preference" component={PreferenceComponent} />
        <Route path="/confirmation" component={SuccessComponent} />
        <Route path="/error" component={ErrorComponent} />
      </Switch>
    </HashRouter>
  );
}

export default Router;
